import { render, staticRenderFns } from "./Strategy-list.vue?vue&type=template&id=8790a16c&"
import script from "./Strategy-list.vue?vue&type=script&lang=js&"
export * from "./Strategy-list.vue?vue&type=script&lang=js&"
import style0 from "./Strategy-list.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports